(function() {
    'use strict';

    let component = {
        transclude: true,
        templateUrl: 'app/js/components/assignments/payment-preferred-assignments.html' + itero.linkVersion,
        controller: controller,
        controllerAs: "ctrl",
        bindings: { payment: '=', titleStyle: '=', marginLeft: '=' }
    };
    
    iteroComponents.component('paymentPreferredAssignments', component);
    
    function controller() {        
        let getTargetLink = function (assignment) {
            let transactionDescriptionStart = 'Transaction: ';
            
            if (assignment.TargetType === 'Receivable' &&
                assignment.TargetDescription.startsWith('Invoice: ') || assignment.TargetDescription.startsWith('Credit Note: '))
                return '#/invoices/' + assignment.TargetItemId;
            if (assignment.TargetType === 'Payment' &&
                assignment.TargetDescription &&
                assignment.TargetDescription.startsWith(transactionDescriptionStart) &&
                assignment.TargetDescription.replace(transactionDescriptionStart, '').length === 24)
                return '#/logs/payment-transactions/'+ assignment.TargetItemId;
            if (assignment.TargetType === 'Refund' &&
                assignment.TargetDescription &&
                assignment.TargetDescription.startsWith(transactionDescriptionStart) &&
                assignment.TargetDescription.replace(transactionDescriptionStart, '').length === 24)
                return '#/logs/payment-refunds/'+ assignment.TargetItemId;
            return '';
        };
        
        this.title = "Initial Assignments";
        this.$onInit = function () {
            let assignments = this.payment.PreferredAssignments;
            if (assignments && assignments.length > 0) {
                assignments.forEach(function (assignment) {
                    assignment.targetLink = getTargetLink(assignment);
                });
            }
        }
    }
})();
